<template>
    <iframe v-if="previewUrl" :src="'/viewer/#' + previewUrl" class="material-preview" allowfullscreen webkitallowfullscreen></iframe>
</template>

<script>
    import materials from '../../api/materials'
    import URI from 'urijs'

    export default {
        name: "material-preview",

        props: {
            'materialId': {
                type: Number,
                required: true
            }
        },

        data() {
            return {
                previewUrl: null
            }
        },

        created() {
            this.getPreviewUrl()
        },

        methods: {

            getPreviewUrl() {
                return materials.preview(this.materialId)
                    .then(response => {
                        this.previewUrl = URI(response.data.url).resource();
                        return response;
                    });
            }
        }
    }
</script>

<style scoped>
    .material-preview {
        width: 100%;
        min-height: 600px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/materials/MaterialPreview.vue